import {useCommonData} from '@udemy-v2/common-data';

/**
 * Hook to check if the user is logged in
 * @returns boolean indicating if user is authenticated
 */
export function useIsLoggedIn(): boolean {
    const commonData = useCommonData();
    return !!commonData?.user?.id;
}
